import { createContext } from 'react';
import { NewElementStyleProvider } from './NewElementStyleProvider';

export const NewElementStyleProviderContext = createContext<NewElementStyleProvider>(new NewElementStyleProvider());
